import React from 'react';
import ReactDOM from 'react-dom';
import { QueryClient, QueryClientProvider } from 'react-query';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import App from './components/App';
import { AuthProvider } from './contexts/Auth';
import './index.css';
import './language';
import reportWebVitals from './reportWebVitals';
import store from './store';
import { getAppInformation, setLogLevels } from './utils/environment';

// logger
setLogLevels();
// Special variables for console
Object.defineProperty(window, 'app_version', { get: getAppInformation });

const ReduxProvider = Provider as any;

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
    },
  },
});

ReactDOM.render(
  <React.StrictMode>
    <BrowserRouter>
      <ReduxProvider store={ store }>
        <QueryClientProvider client={ queryClient }>
          <AuthProvider>
            <App />
          </AuthProvider>
        </QueryClientProvider>
      </ReduxProvider>
    </BrowserRouter>
  </React.StrictMode>,
  document.getElementById('root'),
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(log.debug))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
